import { createTrackEvent as trackEvent } from 'utils/segment';
import { JSON_VIEW, TABLE_VIEW } from 'modules/catalogTable/constants';
import * as t from './actionTypes';

export const formatCreateCatalogEvent = (e) => ({
  catalog_name: e.catalogName,
  creation_method: 'ui',
});

export const formatDisplaySettingEvent = (e) => {
  const { isDisplayTable } = e;
  return { styleSelected: isDisplayTable ? TABLE_VIEW : JSON_VIEW };
};

export default {
  [t.CREATE_CATALOG_RESPONSE]: trackEvent(
    'Catalog Created',
    ['catalogName'],
    formatCreateCatalogEvent,
  ),
  [t.UPDATE_CATALOG_DISPLAY_SETTING]: trackEvent(
    'Catalog Items View Style Changed',
    ['isDisplayTable'],
    formatDisplaySettingEvent,
  ),
  [t.OPEN_CUSTOMIZE_TABLE_COLUMNS_MODAL]: trackEvent('Catalog Page Column Customization Clicked'),
  [t.CHANGE_TABLE_COLUMNS]: trackEvent('Catalog Page Column Customization Applied', [
    'enabledColumns',
    'disabledColumns',
    'reordered',
  ]),
  [t.CHANGE_TABLE_PAGE_SIZE]: trackEvent('Catalog Items View Page Size Changed', [
    'currentPageSize',
    'newPageSize',
  ]),
  [t.FILTER_TABLE]: trackEvent('Catalog Page Filtered', ['filter']),
  [t.REFRESH_TABLE]: trackEvent('Catalog Refreshed'),
};
